<template>
    <b-row class="no-gutters">
      <b-col sm="12" xl="8">
        <b-card>
          <template slot="header">
            {{ medId() ? medium.name + ' Details' : 'New Medium' }}
            <b-badge v-if="medId()" class="border ml-3 bg-white text-muted">
              {{ medium.name }}
            </b-badge>
          </template>
          <b-form>
            <b-row>
              <b-col>
                <b-form-group
                  label="App/Site Name"
                  description="Reference title of app or site">
                  <b-form-input
                    type="text"
                    v-model="medium.name"
                    required
                    placeholder="Fun App Name">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Domain"
                  description="Website for this app or site">
                  <b-form-input
                    type="text"
                    v-model="medium.domain"
                    required
                    placeholder="funapp.com">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Content Categories"
                  description="Categories of typical content">
                  <mulselect
                    :options="cats"
                    :values="medium.cats"
                    :limit="3">
                  </mulselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Type"
                  description="App or site">
                  <b-form-select
                    type="text"
                    v-model="medium.type"
                    :options="typeOptions"
                    required
                    placeholder="Fun App Name">
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-collapse id="bundle-collapse" :visible="medium.type === 'APP'"
                        :class="{ 'no-transition': !this.transition }">
              <b-row>
                <b-col>
                  <b-form-group
                    label="App bundle"
                    description="Play or App Store bundle">
                    <b-form-input
                      type="text"
                      v-model="medium.bundle"
                      required
                      placeholder="Fun App Name">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Store URL"
                    description="App or play store URL">
                    <b-form-input
                      type="text"
                      v-model="medium.storeurl"
                      required
                      placeholder="Fun App Name">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-collapse>
            <b-row>
              <b-col>
                <b-form-group
                  label="External App/Site ID"
                  description="The app or site id value sent to us in the bid request if RTB,
                  used to recognize this property by mapping your site id to ours. Not required but suggested to enable
                  demand partner targeting and matching report field names">
                  <b-form-input v-model="medium.external_id" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Blocked Categories"
                  description="Blocked creative categories for this site or app">
                  <mulselect
                    :options="cats"
                    :values="medium.bcat"
                    :limit="10">
                  </mulselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Blocked Advertiser Domains">
                  <string-list-editor :values="medium.badv"
                                      placeholder="Enter domain"></string-list-editor>
                </b-form-group>
              </b-col>
            </b-row>
            <!--
            <b-row>
              <b-col md="12">
                <b-form-group label="Server Bidder Medium Wide IDs">
                  <prebid-bidders v-model="medium" :server-only="true"></prebid-bidders>
                </b-form-group>
              </b-col>
            </b-row>
            -->
            <b-btn @click="save()" variant="primary">Save</b-btn>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
</template>

<script>
    import {PublisherApi} from '@/publisher/api'
    import Mulselect from '@/components/Mulselect'
    import iab from '@/assets/iab'
    import StringListEditor from '@/components/StringListEditor'
    import PrebidBidders from './Zone/PrebidBidders'

    export default {
        props: {
            cid: {required: true},
            mid: {required: true}
        },
        created () {
            if (this.medId()) {
                PublisherApi.mediumDetails(this.companyId(), this.medId()).then((medium) => {
                    this.medium = Object.assign(this.defaultMed(), medium)
                })
            }
        },
        data() {
            return {
                transition: false,
                medium: this.defaultMed(),
                cats: iab,
                typeOptions: [
                    {value: 'SITE', text: 'Website'},
                    {value: 'APP', text: 'App'}
                ]
            }
        },
        methods: {
            defaultMed() {
                return {
                    company_id: this.companyId(),
                    cats: [],
                    bcat: [],
                    badv: [],
                    bidders: []
                }
            },
            medId() {
                return this.mid === 'new' ? null : this.mid
            },
            companyId() {
                return this.cid ? this.cid : auth.details().company_id
            },
            save() {
                if (!this.valid) {
                    return this.$notify.warning('Please complete all fields')
                }
                PublisherApi.publisherMediumSet(this.medium).then((data) => {
                    this.$notify.success('Updated')
                    this.$router.go(-1)
                }, (err) => {
                    this.$notify.error(err)
                })
            }
        },
        computed: {
            valid() {
                let m = this.medium
                return m.company_id &&
                  m.name && m.name.length &&
                  m.domain && m.domain.length &&
                  m.type && (m.type === 'APP' ? (m.bundle && m.bundle.length) : true);
            },
            collapseBundle() {
                return this.medium.type === 'APP'
            }
        },
        components: {
            Mulselect,
            StringListEditor,
            PrebidBidders
        }
    }
</script>

<style scoped>
  .no-transition {
    transition: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/publisher/pages/PublisherMediumSettings.vue